module.exports = __webpack_public_path__ + "assets/img/btn-view-e7a2ea99.png";